<template>
    <div class="add-collaborator-config">
        <div class="config-field">
            <label>Eklenecek İşbirlikçiler</label>
            <a-select
                v-model="localConfig.userList"
                mode="multiple"
                placeholder="Kullanıcılar seçin"
                style="width: 100%;"
                @change="emitChange"
            >
                <a-select-option
                    v-for="user in users"
                    :key="user._id"
                    :value="user._id"
                >
                    {{ user.name }}
                </a-select-option>
            </a-select>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "AddCollaboratorConfig",
    props: {
        value: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            localConfig: { userList: [] }
        };
    },
    computed: {
        ...mapState({
            users: state => state.user.users.data
        })
    },
    watch: {
        value: {
            handler(newVal) {
                if (newVal) {
                    this.localConfig = JSON.parse(JSON.stringify(newVal));
                }
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        emitChange() {
            this.$emit("input", JSON.parse(JSON.stringify(this.localConfig)));
        }
    }
};
</script>

<style lang="scss" scoped>
.add-collaborator-config {
    .config-field {
        label {
            display: block;
            font-weight: 600;
            margin-bottom: 8px;
            color: #1a1a1a;
        }
    }
}
</style>
